module.exports = __webpack_public_path__ + "static/logo-42bc64a4a6c28c5bf5d40f4a79fe7a1e.png";